import { render } from "./CurrencyDollar.vue?vue&type=template&id=2f00c344"
import script from "./CurrencyDollar.vue?vue&type=script&lang=js"
export * from "./CurrencyDollar.vue?vue&type=script&lang=js"
script.render = render

export default script